/* eslint-disable indent */
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
// import { createStore, applyMiddleware, compose } from 'redux';
// import thunk from 'redux-thunk';
// // import { logger } from 'redux-logger';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {
  setAuthorizationToken,
  setAxiosTimezone,
} from "./libs/set_auth_token.utils";
import store from "./store";
import { AUTH_USER } from "./actions/Auth.action";
import {
  actionChangeTheme,
  actionGetAppSettings,
  actionGetThemeByDomain
} from "./actions/AppSettings.action";
import EventEmitter from "./libs/Events.utils";
import { connectToSocket } from "./libs/socket.utils";
import { GoogleOAuthProvider } from '@react-oauth/google';
import constants from './config/constants';

setAxiosTimezone();
if (localStorage.theme) {
  store.dispatch(actionChangeTheme(localStorage.theme));
} else {
  store.dispatch(actionChangeTheme("light"));
}

// Initial theme fetch
store.dispatch(actionGetThemeByDomain());

if (localStorage.jwt_token) {
  setAuthorizationToken(localStorage.jwt_token);
  store.dispatch({
    type: AUTH_USER,
    payload: {
      ...JSON.parse(localStorage.user),
      token: localStorage.jwt_token,
    },
  });
  // store.dispatch(actionGetDashboard());
  store.dispatch(actionGetAppSettings());
  connectToSocket(localStorage.jwt_token);
} else {
  connectToSocket();
}

// Subscribe to theme changes to update favicon dynamically
store.subscribe(() => {
  const state = store.getState();
  const domainTheme = state.app_setting?.domainTheme;
  const favIcon = domainTheme?.fav_icon || domainTheme?.theme?.fav_icon;
  if (favIcon) {
    let link = document.querySelector("link[rel='shortcut icon']") || document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "shortcut icon";
      document.head.appendChild(link);
    }
    link.href = favIcon;
  }
});

// Listen for theme update events from socket (triggered by admin panel save)
EventEmitter.subscribe(EventEmitter.THEME_UPDATED, (data) => {
  console.log('Theme update received via socket, refreshing theme...');
  store.dispatch(actionGetThemeByDomain());
});

// Poll for theme updates every 30 seconds to pick up changes from admin panel
const themePollInterval = setInterval(() => {
  if (!localStorage.jwt_token) {
    store.dispatch(actionGetThemeByDomain());
  }
}, 30000);

if (window.cleanupFunctions) {
  window.cleanupFunctions.push(() => clearInterval(themePollInterval));
} else {
  window.cleanupFunctions = [() => clearInterval(themePollInterval)];
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId={constants.GOOGLE_AUTH_KEY}>
  {/* // <React.StrictMode> */}
  <Provider store={store}>
    <App />
  </Provider>
  {/* // </React.StrictMode> */}
  </GoogleOAuthProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
